<template>
  <div>
    <Header v-if="id==4"></Header>
    <div>
        <!-- 最新活动 -->
        <latest-activity v-if="id==1"></latest-activity>
        <!-- 了解索道云 -->
        <ljsdy v-if="id==4"></ljsdy>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
    import Header from '../../components/common/header.vue'
    import LatestActivity from './latestActivity/latestActivity.vue'
    import Ljsdy from './ljsdy/ljsdy.vue'
    import Footer from '../../components/common/footer.vue'
    export default {
        data() {
            return {
                id: 0,
            }
        },
        components: {
            Header,
            LatestActivity,
            Ljsdy,
            Footer,
        },
        watch: {
            '$route' (to, from) {
                this.getId()
            }
        },
        created() {
            this.getId();
        },
        methods: {
            getId() {
                this.id = window.location.href.substr(window.location.href.lastIndexOf('/') + 1, 2);
            }
        },
    }
</script>
<style lang="scss" scoped="scoped">
</style>